<template>
  <section>
    <Load v-if="isLoading" />

    <template v-if="order.data">
      <div
        v-if="isBnn"
        class="full-page content-center text-dark-gray pt-4 pt-md-8"
      >
        <v-container>
          <Wording
            v-if="order.data.length === 0"
            :image="require('@/assets/icon/fail.svg')"
            color="red"
            title="ไม่พบเลขที่ใบจองหรือทำรายการไม่สำเร็จ"
            dashed
            showRefId
            desc="กรุณาสั่งซื้อสินค้าอีกครั้ง"
            desc2="หากคุณพบปัญหากรุณาสั่งซื้ออีกครั้ง หรือติดต่อเจ้าหน้าที่ (fb)"
          />

          <template
            v-if="
              order.data.length !== 0 &&
                order.data.status === ORDER_STATUS.COMPLETE
            "
          >
            <Wording
              v-if="order.data.payment_is_deposit"
              :image="require('@/assets/icon/success.svg')"
              title="ยืนยันการชำระเงิน"
              :refId="order.data.ref_id"
              :amount="order.data.total_deposit"
              :depositAmount="order.data.product_price_deposit"
              :totalAmount="totalPriceDeposit"
              :descTotalAmount="
                order.data.status_2nd === ORDER_STATUS.COMPLETE
                  ? ''
                  : '(รอดำเนินการ)'
              "
              :status2nd="order.data.status_2nd"
              :depositNumber="depositNumber"
              color="green"
              isDeposit
              dashed
              showRefId
              desc="ระบบได้รับการชำระเงินแล้ว"
              desc2="รอรับรายละเอียดได้ทางอีเมลของคุณ"
            />
            <Wording
              v-else
              :image="require('@/assets/icon/success.svg')"
              title="ยืนยันการชำระเงิน"
              :refId="order.data.ref_id"
              :amount="amount"
              color="green"
              dashed
              showRefId
              desc="ระบบได้รับการชำระเงินแล้ว"
              desc2="รอรับรายละเอียดได้ทางอีเมลของคุณ"
            />
          </template>

          <Wording
            v-if="
              order.data.length !== 0 &&
                order.data.status === ORDER_STATUS.OK
            "
            :image="require('@/assets/icon/success.svg')"
            title="ชำระเงินมัดจำสำเร็จ"
            :refId="order.data.ref_id"
            :depositNumber="depositNumber"
            color="black"
            dashed
            showRefId
            desc="โปรดชำระยอดที่เหลือได้ที่สาขาที่ท่านเลือก"
            desc2="รอรับรายละเอียดได้ทางอีเมลของคุณ"
          />

          <Wording
            v-if="
              order.data.length !== 0 &&
                order.data.status === ORDER_STATUS.CREATE
            "
            :image="require('@/assets/icon/process.svg')"
            title="กำลังดำเนินการ"
            :refId="order.data.ref_id"
            color="black"
            dashed
            showRefId
            desc="ระบบได้รับคำสั่งซื้อ หากคุณได้ชำระค่าสินค้าแล้ว กรุณารอการติดต่อกลับไป"
            desc2="หากคุณพบปัญหากรุณาสั่งซื้ออีกครั้ง หรือติดต่อเจ้าหน้าที่ (fb)"
          />

          <template
            v-if="
              order.data.length !== 0 &&
                order.data.status === ORDER_STATUS.PROCESS
            "
          >
            <FlashMessagePayAtStore
              v-if="order.data.is_pay_at_store"
              :image="require('@/assets/icon/alarm.svg')"
              :refId="order.data.ref_id || order.data.order"
              :showRefId="true"
            />
            <Wording
              v-else
              :image="require('@/assets/icon/process.svg')"
              title="กำลังดำเนินการ"
              :refId="order.data.ref_id"
              color="black"
              dashed
              showRefId
              desc="ระบบได้รับคำสั่งซื้อ หากคุณได้ชำระค่าสินค้าแล้ว กรุณารอการติดต่อกลับไป"
              desc2="หากคุณพบปัญหากรุณาสั่งซื้ออีกครั้ง หรือติดต่อเจ้าหน้าที่ (fb)"
            />
          </template>

          <template
            v-if="
              order.data.length !== 0 &&
                order.data.status === ORDER_STATUS.SUCCESS
            "
          >
            <Wording
              v-if="
                order.data.itec_sale_order_status ===
                  ORDER_STATUS.OK && order.data.payment_is_deposit
              "
              :image="require('@/assets/icon/process.svg')"
              title="กำลังดำเนินการ"
              :refId="order.data.ref_id"
              color="green"
              dashed
              showRefId
              desc="กำลังดำเนินการชำระเงินส่วนที่เหลือ"
              desc2="เราจะส่งอีเมล์และรายละเอียดให้กับคุณทางอีเมล์ ขอขอบพระคุณ"
            />
            <Wording
              v-else-if="
                order.data.itec_sale_order_status ===
                  ORDER_STATUS.OK &&
                  order.data.status_2nd === ORDER_STATUS.COMPLETE
              "
              :image="require('@/assets/icon/success.svg')"
              title="ทำรายการสำเร็จ"
              :refId="order.data.ref_id"
              :amount="amount"
              color="green"
              dashed
              showRefId
              desc="ระบบได้รับการชำระเงินแล้ว"
              desc2="เราจะส่งอีเมล์และรายละเอียดให้กับคุณทางอีเมล์ ขอขอบพระคุณ"
            />
            <Wording
              v-else
              :image="require('@/assets/icon/success.svg')"
              title="ทำรายการสำเร็จ"
              :refId="order.data.ref_id"
              :amount="amount"
              color="green"
              dashed
              showRefId
              desc="ระบบได้รับการชำระเงินแล้ว"
              desc2="เราจะส่งอีเมล์และรายละเอียดให้กับคุณทางอีเมล์ ขอขอบพระคุณ"
            />
          </template>

          <Wording
            v-if="
              order.data.length !== 0 &&
                order.data.status === ORDER_STATUS.CANCEL
            "
            :image="require('@/assets/icon/fail.svg')"
            title="ระบบทำการยกเลิกรายการแล้ว"
            :refId="order.data.ref_id"
            color="red"
            dashed
            desc="รายการนี้ได้ถูกยกเลิกแล้ว"
            desc2="หากคุณพบปัญหากรุณาสั่งซื้ออีกครั้ง หรือติดต่อเจ้าหน้าที่ (fb)"
          />

          <div
            class="w-full pt-6 pt-md-8"
            v-if="
              order.data.status === ORDER_STATUS.COMPLETE ||
                isProcessingPayAtStore
            "
          >
            <OrderDetail
              :isShowShipping="isProcessingPayAtStore ? false : true"
            />
          </div>
        </v-container>
      </div>

      <template v-else>
        <OrderDetailStudio7 />
      </template>
    </template>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Wording from '@/components/Wording'
import OrderDetail from '@/components/bnn/OrderDetail'
import { ORDER_STATUS } from '@/config/order'
import isBnn from '@/config/isBnn'

export default {
  name: 'Success',

  computed: {
    ...mapState({
      order: state => state.order,
      isLoading: state => state.order.isLoading,
      isPayAtStoreExpired: state => state.order.isExpired,
    }),

    ...mapGetters({
      status: 'order/orderStatus',
    }),

    amount() {
      if (this.order?.data?.paid_amount_2nd) {
        return this.order?.data?.paid_amount_2nd
      }
      return this.order.data?.total_deposit
    },

    depositNumber() {
      return this.order?.data?.deposit_number ?? 'กำลังดำเนินการ'
    },

    totalPriceDeposit() {
      const total =
        this.order?.data?.status_2nd === this.ORDER_STATUS.COMPLETE
          ? parseFloat(this.order?.data?.paid_amount_2nd) ||
            parseFloat(this.order?.data?.total_price)
          : parseFloat(this.order?.data?.total_price)

      const discount = parseFloat(this.order?.data?.total_deposit)

      return total - discount ?? 0
    },

    isProcessingPayAtStore() {
      return (
        this.order?.data?.status === this.ORDER_STATUS.PROCESS &&
        this.order?.data?.is_pay_at_store
      )
    },
  },

  data() {
    return {
      timer: null,
      ORDER_STATUS,
      isBnn,
      hasSentPurchase: false, // กันยิง event purchase ซ้ำ
    }
  },

  components: {
    Wording,
    OrderDetail,
    FlashMessagePayAtStore: () =>
      import('@/components/bnn/FlashMessagePayAtStore'),
    Load: () => import('@/views/Load'),
    OrderDetailStudio7: () =>
      import('@/components/studio7/OrderDetailStudio7'),
  },

  watch: {
    isPayAtStoreExpired(val, oldVal) {
      if (val && val !== oldVal) {
        this.timer = setInterval(this.refetch, 1800000)
      }
    },
    status(val, oldVal) {
      this.setLatestSlug()
      this.trySendPurchase()

      const {
        CREATE,
        PROCESS,
        PRE_COMPLETE,
        COMPLETE,
      } = this.ORDER_STATUS

      if (
        this.status &&
        ![CREATE, PROCESS, PRE_COMPLETE].includes(this.status)
      ) {
        this.cancelAutoUpdate()
        this.$store.dispatch(
          'order/unsubscribeOrderStatus',
          this.$route.params.uid,
        )

        if (val && oldVal && val !== oldVal && val === COMPLETE) {
          this.refetch()
        }
      } else {
        if (val && oldVal && val !== oldVal) {
          this.refetch()
        } else {
          this.$store.dispatch(
            'order/subscribeOrderStatus',
            this.$route.params.uid,
          )
        }
      }
    },
  },

  mounted() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    this.sentEventGoogleTAG()
    this.trySendPurchase()
  },

  created() {
    this.refetch()
    this.timer = setInterval(this.refetch, 1800000) // 30 minutes
  },

  beforeUnmount() {
    this.cancelAutoUpdate()
  },

  beforeDestroy() {
    this.cancelAutoUpdate()
  },

  methods: {
    setLatestSlug() {
      if (this.order?.data?.campaign?.slug) {
        localStorage.setItem(
          'productLatestVisit',
          this.order.data.campaign.slug,
        )
      }
    },

    async refetch() {
      const uid = this.$route.params.uid
      if (uid) {
        try {
          await this.$store.dispatch('order/getOrder', uid)
          this.$store.dispatch(
            'order/subscribeOrderStatus',
            this.$route.params.uid,
          )
        } catch {
          this.cancelAutoUpdate()
        }
      }
      this.$forceUpdate()
    },

    cancelAutoUpdate() {
      clearInterval(this.timer)
    },

    sentEventGoogleTAG() {
      try {
        window.dataLayer.push({
          event: 'Thank You',
          page: 'thank',
          data: {
            full_name: this.order.data.full_name,
            sku: this.order.data.sku,
            status: this.order.data.status,
            total_deposit: this.order.data.total_deposit,
            total_price: this.order.data.total_price,
            bundle_products: this.order.data.bundle_products,
          },
        })
      } catch (e) {
        return
      }
    },

    // ยิง event purchase ครั้งเดียว เมื่อออเดอร์ชำระเงินสำเร็จ (COMPLETE / SUCCESS)
    trySendPurchase() {
      const { COMPLETE, SUCCESS } = this.ORDER_STATUS

      if (
        this.hasSentPurchase ||
        this.order?.data?.length === 0 ||
        ![COMPLETE, SUCCESS].includes(this.status)
      ) {
        return
      }

      this.hasSentPurchase = true
      this.sentPurchaseEvent()
    },

    // สร้าง payload รูปแบบ GA4 ecommerce แล้ว push เข้า dataLayer
    sentPurchaseEvent() {
      try {
        const data = this.order.data

        // รวมรายการสินค้า: สินค้าหลัก + bundle ทั้งหมด
        const items = []

        if (data.product_main?.sku) {
          items.push({
            item_id: data.product_main.sku,
            item_name: data.product_main.name,
            price: Number(data.product_main.price) || 0,
            quantity: 1,
          })
        }

        ;(data.bundle_products || []).forEach((bundle, index) => {
          items.push({
            item_id: bundle.sku,
            item_name: bundle.name,
            item_category: bundle.type,
            price: Number(bundle.price_srp) || 0,
            quantity: 1,
            index: index + 1,
          })
        })

        // ค่าจัดส่ง: ดึงจาก bundle ที่เป็น delivery ถ้ามี
        const shippingBundle = (data.bundle_products || []).find(
          b => b.type === 'delivery',
        )
        const shipping = shippingBundle
          ? Number(
              shippingBundle.price_ship ?? shippingBundle.price_srp,
            ) || 0
          : 0

        // Discount: ดึงจาก order.discount + order.discount_coupon
        const discount =
          Number(data.discount) + Number(data.discount_coupon) || 0

        const payment = {
          payment_type: data.payment_type ?? '',
          deposit: data.deposit ?? 0,
          remaining: data.remaining ?? 0,
        }

        window.dataLayer = window.dataLayer || []
        // เคลียร์ ecommerce เดิมก่อน กันข้อมูลจาก event ก่อนหน้าปนกัน (แนวทาง GA4)
        window.dataLayer.push({ ecommerce: null })
        window.dataLayer.push({
          event: 'purchase',
          ecommerce: {
            transaction_id: data.order,
            value: Number(data.total_price) || 0,
            currency: 'THB',
            coupon: data.coupon_code ?? '',
            coupon_id: data.coupon_used ?? '', // coupon_id จากระบบ backend
            payment,
            shipping,
            discount,
            items,
          },
        })
      } catch (e) {
        return
      }
    },
  },
}
</script>

<style lang="stylus">

.h-full {
  margin-top: 80px;
  min-height: 100dhv;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hr-dash {
  overflow: hidden;
  position: relative;
  text-align: center;
  padding: 10px;
  margin-bottom: 20px;
  width: 50%;
}

.hr-dash:before {
  content: '';
  position: absolute;
  border-bottom: 5px dashed $color-gray-200;
  top: -3px;
  bottom: -3px;
  left: -3px;
  right: -3px;
}
</style>
